// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import tippy        from 'tippy.js';

export default class Tooltip extends WebComponent {
  didMount() {
    tippy(this.element, {
      arrow: true,
      theme: 'esp',
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/components/Tooltip.js